<template>
  <a-card :bordered="false" title="申请发票" :headStyle="{ fontSize: '18px' }">
    <a-tabs default-active-key="2" @tabClick="goApply">
      <a-tab-pane key="1" tab="可开票订单">
        <!-- <InvoiceOrder></InvoiceOrder> -->
      </a-tab-pane>
      <a-tab-pane key="2" tab="开票历史">
        <a-card
          :bordered="false"
          :bodyStyle="{ padding: '0px' }"
          :headStyle="{ borderBottom: '0px', paddingLeft: '0px' }"
        >
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">发票申请信息</span>
            </a-col>
          </a-row>
          <a-table rowKey="id" :columns="columns" :data-source="dataList">
            <span slot="headerType" slot-scope="text">{{ text == 1 ? '企业' : '' }}</span>
            <span slot="invoiceType" slot-scope="text">{{ text | invoiceTypeName }}</span>
            <span slot="action" slot-scope="text, record">
              <a @click="showModal(record.id)">查看</a>
            </span>
          </a-table>
        </a-card>
        <a-card
          :bordered="false"
          :bodyStyle="{ padding: '0px' }"
          :headStyle="{ borderBottom: '0px', paddingLeft: '0px' }"
        >
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">订单明细信息</span>
            </a-col>
          </a-row>
          <custom-page-table ref="table" rowKey="orderNo" :columns="columnsDetail" :requestPromise="loadPromise">
          </custom-page-table>
        </a-card>
      </a-tab-pane>
    </a-tabs>
    <a-modal title="发票详情" :visible="visible" :width="670" @cancel="handleCancel" :footer="null">
      <div>
        <div style="font-size: 18px;margin-left:34px">
          <span>发票开具总金额：</span>
          <span style="color: #f25001;">{{ detailList.invoiceAmount }}</span
          >元
        </div>
        <div class="form">
          <span>订单数量：</span>
          {{ detailList.orderNum }}
        </div>
        <div class="form">
          <span>申请时间：</span>
          {{ detailList.applyTime }}
        </div>
        <div class="form">
          <span>发票抬头：</span>
          {{ detailList.invoiceHeader }}
        </div>
        <div class="form">
          <span>抬头类型：</span>
          {{ detailList.headerTypeStr }}
        </div>
        <div class="form">
          <span>发票类型：</span>
          {{ detailList.invoiceTypeStr }}
        </div>
        <div class="form">
          <span>纳税人识别号：</span>
          {{ detailList.taxpayerIdentificationNumber }}
        </div>
        <div class="form">
          <span>收票人姓名：</span>
          {{ detailList.receiveInvoiceName }}
        </div>
        <div class="form">
          <span>收票人电话：</span>
          {{ detailList.receiveInvoiceMobile }}
        </div>
        <div v-if="detailList.invoiceType == 1" class="form">
          <span>收票人邮箱：</span>
          {{ detailList.receiveInvoiceLinkContent }}
        </div>
        <div v-else>
          <div class="form">
            <span>收票地址：</span>
            {{ detailList.receiveInvoiceLinkContent }}
          </div>
          <div class="form" style="margin-top: 30px;">
            <span>快递单号：</span>
            {{ detailList.expressDelivery }}
          </div>
        </div>
        <div class="form">
          <span>备注：</span>
          {{ detailList.remark }}
        </div>
      </div>
    </a-modal>
  </a-card>
</template>

<script>
import InvoiceHistory from '../components/InvoiceHistory'
import InvoiceOrder from '../components/InvoiceOrder'

export default {
  name: 'HistoricalDetails',
  components: {
    InvoiceHistory,
    InvoiceOrder
  },
  data() {
    return {
      loadPromise: params => this.getRecordData(params),
      columns: [
        {
          title: '申请时间',
          dataIndex: 'applyTime'
        },
        {
          title: '发票抬头',
          dataIndex: 'invoiceHeader'
        },
        {
          title: '金额',
          dataIndex: 'invoiceAmount'
        },
        {
          title: '抬头类型',
          dataIndex: 'headerTypeStr'
        },
        {
          title: '发票类型',
          dataIndex: 'invoiceTypeStr'
        },
        {
          title: '状态',
          dataIndex: 'statusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      columnsDetail: [
        {
          title: '订单编号',
          dataIndex: 'orderNo'
        },
        {
          title: '商品信息',
          dataIndex: 'productMsg',
          width: '40%'
        },
        {
          title: '金额',
          dataIndex: 'orderAmount'
        },
        {
          title: '支持发票类型',
          dataIndex: 'invoiceType'
        },
        {
          title: '状态',
          dataIndex: 'statusStr',
          width: '80px'
        }
      ],
      id: this.$route.query.id,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {},
      visible: false,
      dataList: [],
      detailList: {}
    }
  },
  mounted() {
    this.getDetailList()
  },
  methods: {
    goApply() {
      this.$router.push({ name: 'ApplyInvoice' })
    },
    showModal() {
      this.visible = true
    },
    handleCancel(e) {
      this.visible = false
    },
    getDetailList() {
      this.getHttpServices()
        .getCloudUserService()
        .post('invoice/v2/getInvoiceDetail', { invoiceId: this.id })
        .then(res => {
          this.detailList = res
          this.dataList.push(res)
          this.getLogUtils().logWithTag('==this.applyData==', this.res)
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    getRecordData(params) {
      params.invoiceId = this.id
      return this.getHttpServices()
        .getCloudUserService()
        .post('invoice/v2/getOrderList', params)
    }
  }
}
</script>
<style scoped>
* {
  padding: 0;
  margin: 0;
}

.form {
  margin: 15px 0 15px 15px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}
</style>
